import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebaseConfig";

export const getHotels = async () => {
  const hotelsCollection = collection(db, "Hotels");
  const snapshot = await getDocs(hotelsCollection);
  const hotels = [];
  snapshot.forEach((doc) => {
    hotels.push({ ...doc.data(), id: doc.id });
  });
  console.log("Fetched hotels:", hotels);
  return hotels;
};

export const getHotelDetails = async (hotelName) => {
  const hotelsCollection = collection(db, "Hotels");
  const snapshot = await getDocs(hotelsCollection);
  let hotelDetails = {};

  snapshot.forEach((doc) => {
    const hotelData = doc.data();
    if (hotelData.Hotel_Description === hotelName) {
      hotelDetails = { ...hotelData, id: doc.id };
    }
  });

  console.log("Fetched hotel details:", hotelDetails);
  // Return an object with details and id properties
  return { details: hotelDetails, id: hotelDetails.id };
};
